<template>
  <div class="d-print-none">
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="d-flex justify-md-end justify-start flex-wrap gap-2">
            <v-btn to="/konzerte">
              <v-icon left>mdi-chevron-left</v-icon>
              Zurück zur Übersicht
            </v-btn>
            <v-btn dark @click="print()" :disabled="!canPrint">
              <v-icon left>mdi-printer</v-icon>
              Jetzt drucken
            </v-btn>
            <v-btn dark @click="downloadAllTickets(batchDownloadId)" data-html2canvas-ignore="true" class="download-ticket-button">
              <v-progress-circular indeterminate :size="16" :width="2" color="white" class="mr-4"
              v-if="generatingPDFStates[batchDownloadId]"></v-progress-circular>
              <v-icon left>mdi-download</v-icon>

              Alle Tickets herunterladen (PDF)
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { ticketDownloadMixin } from "@/mixins/ticketDownloadMixin";
import { mapGetters } from "vuex";

export default {
  name: "PrintSingle",
  props: {
    concertID: String,
  },
  mixins: [ticketDownloadMixin],
  data: () => ({
    batchDownloadId: 'batch-download',
    generatingPDFStates: {},
  }),
  computed: {
    ...mapGetters(["isPrintableForID", "getConcertById"]),
    canPrint() {
      return this.isPrintableForID(this.concertID)
    },

    concert() {
      return this.getConcertById(this.concertID)
    },
  },
  methods: {
    print() {
      window.print();
    },
  }
};
</script>

<style>
.gap-2 {
  gap: 0.5rem;
}
</style>
